import { render, staticRenderFns } from "./UpdateBidPrice.vue?vue&type=template&id=3540fef7&scoped=true&"
import script from "./UpdateBidPrice.vue?vue&type=script&lang=js&"
export * from "./UpdateBidPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540fef7",
  null
  
)

export default component.exports